import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ReadScimGroupMapping } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { scimQueryKey } from './invalidate-scim-queries';

export type GetScimGroupMappingsParams = {
  organizationId: string;
};

export const getScimGroupMappings = async (
  params: GetScimGroupMappingsParams,
): Promise<ReadScimGroupMapping[]> => {
  return await tinctApi.scim.getScimGroupMappings(params.organizationId);
};

/**
 * Every group the workspace's directory pushed, with the role it maps to (`null`: none). Admins only
 * (403 otherwise); a refused read is not retried.
 */
export const useGetScimGroupMappings = (
  params: GetScimGroupMappingsParams,
  options?: Omit<UseQueryOptions<ReadScimGroupMapping[], ApiError>, 'queryKey'>,
) =>
  useQuery({
    queryKey: [...scimQueryKey(params.organizationId), 'group-mappings'],
    queryFn: () => getScimGroupMappings(params),
    retry: false,
    ...options,
  });
